import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _TopicListItem;
import Component from "@glimmer/component";
import { concat, hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import { service } from "@ember/service";
import { eq, gt } from "truth-helpers";
import PluginOutlet from "discourse/components/plugin-outlet";
import ActionList from "discourse/components/topic-list/action-list";
import ActivityColumn from "discourse/components/topic-list/activity-column";
import ParticipantGroups from "discourse/components/topic-list/participant-groups";
import PostCountOrBadges from "discourse/components/topic-list/post-count-or-badges";
import PostersColumn from "discourse/components/topic-list/posters-column";
import PostsCountColumn from "discourse/components/topic-list/posts-count-column";
import TopicExcerpt from "discourse/components/topic-list/topic-excerpt";
import TopicLink from "discourse/components/topic-list/topic-link";
import UnreadIndicator from "discourse/components/topic-list/unread-indicator";
import TopicPostBadges from "discourse/components/topic-post-badges";
import TopicStatus from "discourse/components/topic-status";
import { topicTitleDecorators } from "discourse/components/topic-title";
import avatar from "discourse/helpers/avatar";
import categoryLink from "discourse/helpers/category-link";
import concatClass from "discourse/helpers/concat-class";
import discourseTags from "discourse/helpers/discourse-tags";
import formatDate from "discourse/helpers/format-date";
import number from "discourse/helpers/number";
import topicFeaturedLink from "discourse/helpers/topic-featured-link";
import { wantsNewWindow } from "discourse/lib/intercept-click";
import DiscourseURL, { groupPath } from "discourse/lib/url";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import { bind } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let TopicListItem = (_class = (_TopicListItem = class TopicListItem extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "historyStore", _descriptor3, this);
    _initializerDefineProperty(this, "messageBus", _descriptor4, this);
    _initializerDefineProperty(this, "router", _descriptor5, this);
    _initializerDefineProperty(this, "site", _descriptor6, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor7, this);
    if (this.includeUnreadIndicator) {
      this.messageBus.subscribe(this.unreadIndicatorChannel, this.onMessage);
    }
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this.messageBus.unsubscribe(this.unreadIndicatorChannel, this.onMessage);
  }
  onMessage(data1) {
    const nodeClassList1 = document.querySelector(`.indicator-topic-${data1.topic_id}`).classList;
    nodeClassList1.toggle("read", !data1.show_indicator);
  }
  get unreadIndicatorChannel() {
    return `/private-messages/unread-indicator/${this.args.topic.id}`;
  }
  get includeUnreadIndicator() {
    return typeof this.args.topic.unread_by_group_member !== "undefined";
  }
  get isSelected() {
    return this.args.selected?.includes(this.args.topic);
  }
  get participantGroups() {
    if (!this.args.topic.participant_groups) {
      return [];
    }
    return this.args.topic.participant_groups.map(name1 => ({
      name: name1,
      url: groupPath(name1)
    }));
  }
  get newDotText() {
    return this.currentUser?.trust_level > 0 ? "" : I18n.t("filters.new.lower_title");
  }
  get tagClassNames() {
    return this.args.topic.tags?.map(tagName1 => `tag-${tagName1}`);
  }
  get expandPinned() {
    if (!this.args.topic.pinned || this.site.mobileView && !this.siteSettings.show_pinned_excerpt_mobile || this.site.desktopView && !this.siteSettings.show_pinned_excerpt_desktop) {
      return false;
    }
    return this.args.expandGloballyPinned && this.args.topic.pinned_globally || this.args.expandAllPinned;
  }
  get shouldFocusLastVisited() {
    return this.site.desktopView && this.args.focusLastVisitedTopic;
  }
  get unreadClass() {
    return this.args.topic.unread_by_group_member ? "" : "read";
  }
  navigateToTopic(topic1, href1) {
    this.historyStore.set("lastTopicIdViewed", topic1.id);
    DiscourseURL.routeTo(href1 || topic1.url);
  }
  highlight(element1, isLastViewedTopic1) {
    element1.classList.add("highlighted");
    element1.setAttribute("data-islastviewedtopic", isLastViewedTopic1);
    element1.addEventListener("animationend", () => element1.classList.remove("highlighted"), {
      once: true
    });
    if (isLastViewedTopic1 && this.shouldFocusLastVisited) {
      element1.querySelector(".main-link .title")?.focus();
    }
  }
  highlightIfNeeded(element1) {
    if (this.args.topic.id === this.historyStore.get("lastTopicIdViewed")) {
      this.historyStore.delete("lastTopicIdViewed");
      this.highlight(element1, true);
    } else if (this.args.topic.highlight) {
      // highlight new topics that have been loaded from the server or the one we just created
      this.args.topic.set("highlight", false);
      this.highlight(element1, false);
    }
  }
  onTitleFocus(event1) {
    event1.target.classList.add("selected");
  }
  onTitleBlur(event1) {
    event1.target.classList.remove("selected");
  }
  applyTitleDecorators(element1) {
    const rawTopicLink1 = element1.querySelector(".raw-topic-link");
    if (rawTopicLink1) {
      topicTitleDecorators?.forEach(cb1 => cb1(this.args.topic, rawTopicLink1, "topic-list-item-title"));
    }
  }
  onBulkSelectToggle(e1) {
    if (e1.target.checked) {
      this.args.selected.addObject(this.args.topic);
      if (this.args.lastCheckedElementId && e1.shiftKey) {
        const bulkSelects1 = Array.from(document.querySelectorAll("input.bulk-select"));
        const from1 = bulkSelects1.indexOf(e1.target);
        const to1 = bulkSelects1.findIndex(el1 => el1.id === this.args.lastCheckedElementId);
        const start1 = Math.min(from1, to1);
        const end1 = Math.max(from1, to1);
        bulkSelects1.slice(start1, end1).filter(el1 => !el1.checked).forEach(checkbox1 => checkbox1.click());
      }
      this.args.updateLastCheckedElementId(e1.target.id);
    } else {
      this.args.selected.removeObject(this.args.topic);
      this.args.updateLastCheckedElementId(null);
    }
  }
  click(e1) {
    if (e1.target.classList.contains("raw-topic-link") || e1.target.classList.contains("post-activity")) {
      if (wantsNewWindow(e1)) {
        return;
      }
      e1.preventDefault();
      this.navigateToTopic(this.args.topic, e1.target.href);
      return;
    }
    // make full row click target on mobile, due to size constraints
    if (this.site.mobileView && e1.target.matches(".topic-list-data, .main-link, .right, .topic-item-stats, .topic-item-stats__category-tags, .discourse-tags")) {
      if (wantsNewWindow(e1)) {
        return;
      }
      e1.preventDefault();
      this.navigateToTopic(this.args.topic, this.args.topic.lastUnreadUrl);
      return;
    }
    if (e1.target.classList.contains("d-icon-thumbtack") && e1.target.closest("a.topic-status")) {
      e1.preventDefault();
      this.args.topic.togglePinnedForUser();
      return;
    }
  }
  keyDown(e1) {
    if (e1.key === "Enter" && e1.target.classList.contains("post-activity")) {
      e1.preventDefault();
      this.navigateToTopic(this.args.topic, e1.target.href);
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <tr
      {{! template-lint-disable no-invalid-interactive }}
      {{didInsert this.applyTitleDecorators}}
      {{didInsert this.highlightIfNeeded}}
      {{on "keydown" this.keyDown}}
      {{on "click" this.click}}
      data-topic-id={{@topic.id}}
      role={{this.role}}
      aria-level={{this.ariaLevel}}
      class={{concatClass
        "topic-list-item"
        (if @topic.category (concat "category-" @topic.category.fullSlug))
        (if (eq @topic @lastVisitedTopic) "last-visit")
        (if @topic.visited "visited")
        (if @topic.hasExcerpt "has-excerpt")
        (if @topic.unseen "unseen-topic")
        (if @topic.unread_posts "unread-posts")
        (if @topic.liked "liked")
        (if @topic.archived "archived")
        (if @topic.bookmarked "bookmarked")
        (if @topic.pinned "pinned")
        (if @topic.closed "closed")
        this.tagClassNames
      }}
    >
      <PluginOutlet
        @name="above-topic-list-item"
        @outletArgs={{hash topic=@topic}}
      />
      {{#if this.site.desktopView}}
        <PluginOutlet @name="topic-list-before-columns" />

        {{#if @bulkSelectEnabled}}
          <td class="bulk-select topic-list-data">
            <label for="bulk-select-{{@topic.id}}">
              <input
                {{on "click" this.onBulkSelectToggle}}
                checked={{this.isSelected}}
                type="checkbox"
                id="bulk-select-{{@topic.id}}"
                class="bulk-select"
              />
            </label>
          </td>
        {{/if}}

        <td class="main-link clearfix topic-list-data" colspan="1">
          <PluginOutlet @name="topic-list-before-link" />

          <span class="link-top-line">{{! no whitespace
          }}<PluginOutlet
              @name="topic-list-before-status"
            />{{! no whitespace
          }}<TopicStatus
              @topic={{@topic}}
            />{{! no whitespace
          }}<TopicLink
              {{on "focus" this.onTitleFocus}}
              {{on "blur" this.onTitleBlur}}
              @topic={{@topic}}
              class="raw-link raw-topic-link"
            />
            {{~#if @topic.featured_link~}}
              &nbsp;
              {{~topicFeaturedLink @topic}}
            {{~/if~}}
            <PluginOutlet
              @name="topic-list-after-title"
            />{{! no whitespace
          }}
            <UnreadIndicator
              @includeUnreadIndicator={{this.includeUnreadIndicator}}
              @topicId={{@topic.id}}
              class={{this.unreadClass}}
            />
            {{~#if @showTopicPostBadges~}}
              <TopicPostBadges
                @unreadPosts={{@topic.unread_posts}}
                @unseen={{@topic.unseen}}
                @newDotText={{this.newDotText}}
                @url={{@topic.lastUnreadUrl}}
              />
            {{~/if~}}
          </span>

          <div class="link-bottom-line">
            {{#unless @hideCategory}}
              {{#unless @topic.isPinnedUncategorized}}
                <PluginOutlet @name="topic-list-before-category" />
                {{categoryLink @topic.category}}
              {{/unless}}
            {{/unless}}

            {{discourseTags @topic mode="list" tagsForUser=@tagsForUser}}

            {{#if this.participantGroups}}
              <ParticipantGroups @groups={{this.participantGroups}} />
            {{/if}}

            <ActionList
              @topic={{@topic}}
              @postNumbers={{@topic.liked_post_numbers}}
              @icon="heart"
              class="likes"
            />
          </div>

          {{#if this.expandPinned}}
            <TopicExcerpt @topic={{@topic}} />
          {{/if}}

          <PluginOutlet @name="topic-list-main-link-bottom" />
        </td>

        <PluginOutlet @name="topic-list-after-main-link" />

        {{#if @showPosters}}
          <PostersColumn @posters={{@topic.featuredUsers}} />
        {{/if}}

        <PostsCountColumn @topic={{@topic}} />

        {{#if @showLikes}}
          <td class="num likes topic-list-data">
            {{#if (gt @topic.like_count 0)}}
              <a href={{@topic.summaryUrl}}>
                {{number @topic.like_count}}
                {{icon "heart"}}
              </a>
            {{/if}}
          </td>
        {{/if}}

        {{#if @showOpLikes}}
          <td class="num likes">
            {{#if (gt @topic.op_like_count 0)}}
              <a href={{@topic.summaryUrl}}>
                {{number @topic.op_like_count}}
                {{icon "heart"}}
              </a>
            {{/if}}
          </td>
        {{/if}}

        <td class={{concatClass "num views topic-list-data" @topic.viewsHeat}}>
          <PluginOutlet @name="topic-list-before-view-count" />
          {{number @topic.views numberKey="views_long"}}
        </td>

        <ActivityColumn @topic={{@topic}} class="num topic-list-data" />

        <PluginOutlet @name="topic-list-after-columns" />
      {{else}}
        <td class="topic-list-data">
          <PluginOutlet @name="topic-list-before-columns" />

          <div class="pull-left">
            {{#if @bulkSelectEnabled}}
              <label for="bulk-select-{{@topic.id}}">
                <input
                  type="checkbox"
                  id="bulk-select-{{@topic.id}}"
                  class="bulk-select"
                />
              </label>
            {{else}}
              <a
                href={{@topic.lastPostUrl}}
                aria-label={{i18n
                  "latest_poster_link"
                  username=@topic.lastPosterUser.username
                }}
                data-user-card={{@topic.lastPosterUser.username}}
              >{{avatar @topic.lastPosterUser imageSize="large"}}</a>
            {{/if}}
          </div>

          <div
            class="topic-item-metadata right"
          >{{! no whitespace
            }}<PluginOutlet
              @name="topic-list-before-link"
            />

            <div
              class="main-link"
            >{{! no whitespace
              }}<PluginOutlet
                @name="topic-list-before-status"
              />{{! no whitespace
              }}<TopicStatus
                @topic={{@topic}}
              />{{! no whitespace
              }}<TopicLink
                {{on "focus" this.onTitleFocus}}
                {{on "blur" this.onTitleBlur}}
                @topic={{@topic}}
                class="raw-link raw-topic-link"
              />
              {{~#if @topic.featured_link~}}
                {{topicFeaturedLink @topic}}
              {{~/if~}}
              <PluginOutlet @name="topic-list-after-title" />
              {{~#if @topic.unseen~}}
                <span class="topic-post-badges">&nbsp;<span
                    class="badge-notification new-topic"
                  ></span></span>
              {{~/if~}}
              {{~#if this.expandPinned~}}
                <TopicExcerpt @topic={{@topic}} />
              {{~/if~}}
              <PluginOutlet @name="topic-list-main-link-bottom" />
            </div>{{! no whitespace
            }}<PluginOutlet
              @name="topic-list-after-main-link"
            />

            <div class="pull-right">
              <PostCountOrBadges
                @topic={{@topic}}
                @postBadgesEnabled={{@showTopicPostBadges}}
              />
            </div>

            <div class="topic-item-stats clearfix">
              <span class="topic-item-stats__category-tags">
                {{#unless @hideCategory}}
                  <PluginOutlet @name="topic-list-before-category" />
                  {{categoryLink @topic.category}}
                {{/unless}}

                {{discourseTags @topic mode="list"}}
              </span>

              <div class="num activity last">
                <span title={{@topic.bumpedAtTitle}} class="age activity">
                  <a href={{@topic.lastPostUrl}}>{{formatDate
                      @topic.bumpedAt
                      format="tiny"
                      noTitle="true"
                    }}</a>
                </span>
              </div>
            </div>
          </div>
        </td>
      {{/if}}
    </tr>
  
*/
{
  "id": "QnPz48Kz",
  "block": "[[[1,\"\\n    \"],[11,\"tr\"],[16,\"data-topic-id\",[30,1,[\"id\"]]],[16,\"role\",[30,0,[\"role\"]]],[16,\"aria-level\",[30,0,[\"ariaLevel\"]]],[16,0,[28,[32,0],[\"topic-list-item\",[52,[30,1,[\"category\"]],[28,[32,1],[\"category-\",[30,1,[\"category\",\"fullSlug\"]]],null]],[52,[28,[32,2],[[30,1],[30,2]],null],\"last-visit\"],[52,[30,1,[\"visited\"]],\"visited\"],[52,[30,1,[\"hasExcerpt\"]],\"has-excerpt\"],[52,[30,1,[\"unseen\"]],\"unseen-topic\"],[52,[30,1,[\"unread_posts\"]],\"unread-posts\"],[52,[30,1,[\"liked\"]],\"liked\"],[52,[30,1,[\"archived\"]],\"archived\"],[52,[30,1,[\"bookmarked\"]],\"bookmarked\"],[52,[30,1,[\"pinned\"]],\"pinned\"],[52,[30,1,[\"closed\"]],\"closed\"],[30,0,[\"tagClassNames\"]]],null]],[4,[32,3],[[30,0,[\"applyTitleDecorators\"]]],null],[4,[32,3],[[30,0,[\"highlightIfNeeded\"]]],null],[4,[32,4],[\"keydown\",[30,0,[\"keyDown\"]]],null],[4,[32,4],[\"click\",[30,0,[\"click\"]]],null],[12],[1,\"\\n      \"],[8,[32,5],null,[[\"@name\",\"@outletArgs\"],[\"above-topic-list-item\",[28,[32,6],null,[[\"topic\"],[[30,1]]]]]],null],[1,\"\\n\"],[41,[30,0,[\"site\",\"desktopView\"]],[[[1,\"        \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-columns\"]],null],[1,\"\\n\\n\"],[41,[30,3],[[[1,\"          \"],[10,\"td\"],[14,0,\"bulk-select topic-list-data\"],[12],[1,\"\\n            \"],[10,\"label\"],[15,\"for\",[29,[\"bulk-select-\",[30,1,[\"id\"]]]]],[12],[1,\"\\n              \"],[11,\"input\"],[16,\"checked\",[30,0,[\"isSelected\"]]],[16,1,[29,[\"bulk-select-\",[30,1,[\"id\"]]]]],[24,0,\"bulk-select\"],[24,4,\"checkbox\"],[4,[32,4],[\"click\",[30,0,[\"onBulkSelectToggle\"]]],null],[12],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,\"td\"],[14,0,\"main-link clearfix topic-list-data\"],[14,\"colspan\",\"1\"],[12],[1,\"\\n          \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-link\"]],null],[1,\"\\n\\n          \"],[10,1],[14,0,\"link-top-line\"],[12],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-status\"]],null],[8,[32,7],null,[[\"@topic\"],[[30,1]]],null],[8,[32,8],[[24,0,\"raw-link raw-topic-link\"],[4,[32,4],[\"focus\",[30,0,[\"onTitleFocus\"]]],null],[4,[32,4],[\"blur\",[30,0,[\"onTitleBlur\"]]],null]],[[\"@topic\"],[[30,1]]],null],[41,[30,1,[\"featured_link\"]],[[[1,\" \"],[1,[28,[32,9],[[30,1]],null]]],[]],null],[8,[32,5],null,[[\"@name\"],[\"topic-list-after-title\"]],null],[1,\"\\n            \"],[8,[32,10],[[16,0,[30,0,[\"unreadClass\"]]]],[[\"@includeUnreadIndicator\",\"@topicId\"],[[30,0,[\"includeUnreadIndicator\"]],[30,1,[\"id\"]]]],null],[41,[30,4],[[[8,[32,11],null,[[\"@unreadPosts\",\"@unseen\",\"@newDotText\",\"@url\"],[[30,1,[\"unread_posts\"]],[30,1,[\"unseen\"]],[30,0,[\"newDotText\"]],[30,1,[\"lastUnreadUrl\"]]]],null]],[]],null],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"link-bottom-line\"],[12],[1,\"\\n\"],[41,[51,[30,5]],[[[41,[51,[30,1,[\"isPinnedUncategorized\"]]],[[[1,\"                \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-category\"]],null],[1,\"\\n                \"],[1,[28,[32,12],[[30,1,[\"category\"]]],null]],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n            \"],[1,[28,[32,13],[[30,1]],[[\"mode\",\"tagsForUser\"],[\"list\",[30,6]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"participantGroups\"]],[[[1,\"              \"],[8,[32,14],null,[[\"@groups\"],[[30,0,[\"participantGroups\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n            \"],[8,[32,15],[[24,0,\"likes\"]],[[\"@topic\",\"@postNumbers\",\"@icon\"],[[30,1],[30,1,[\"liked_post_numbers\"]],\"heart\"]],null],[1,\"\\n          \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"expandPinned\"]],[[[1,\"            \"],[8,[32,16],null,[[\"@topic\"],[[30,1]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-main-link-bottom\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-after-main-link\"]],null],[1,\"\\n\\n\"],[41,[30,7],[[[1,\"          \"],[8,[32,17],null,[[\"@posters\"],[[30,1,[\"featuredUsers\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[8,[32,18],null,[[\"@topic\"],[[30,1]]],null],[1,\"\\n\\n\"],[41,[30,8],[[[1,\"          \"],[10,\"td\"],[14,0,\"num likes topic-list-data\"],[12],[1,\"\\n\"],[41,[28,[32,19],[[30,1,[\"like_count\"]],0],null],[[[1,\"              \"],[10,3],[15,6,[30,1,[\"summaryUrl\"]]],[12],[1,\"\\n                \"],[1,[28,[32,20],[[30,1,[\"like_count\"]]],null]],[1,\"\\n                \"],[1,[28,[32,21],[\"heart\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,9],[[[1,\"          \"],[10,\"td\"],[14,0,\"num likes\"],[12],[1,\"\\n\"],[41,[28,[32,19],[[30,1,[\"op_like_count\"]],0],null],[[[1,\"              \"],[10,3],[15,6,[30,1,[\"summaryUrl\"]]],[12],[1,\"\\n                \"],[1,[28,[32,20],[[30,1,[\"op_like_count\"]]],null]],[1,\"\\n                \"],[1,[28,[32,21],[\"heart\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,\"td\"],[15,0,[28,[32,0],[\"num views topic-list-data\",[30,1,[\"viewsHeat\"]]],null]],[12],[1,\"\\n          \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-view-count\"]],null],[1,\"\\n          \"],[1,[28,[32,20],[[30,1,[\"views\"]]],[[\"numberKey\"],[\"views_long\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[8,[32,22],[[24,0,\"num topic-list-data\"]],[[\"@topic\"],[[30,1]]],null],[1,\"\\n\\n        \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-after-columns\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"td\"],[14,0,\"topic-list-data\"],[12],[1,\"\\n          \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-columns\"]],null],[1,\"\\n\\n          \"],[10,0],[14,0,\"pull-left\"],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"              \"],[10,\"label\"],[15,\"for\",[29,[\"bulk-select-\",[30,1,[\"id\"]]]]],[12],[1,\"\\n                \"],[10,\"input\"],[15,1,[29,[\"bulk-select-\",[30,1,[\"id\"]]]]],[14,0,\"bulk-select\"],[14,4,\"checkbox\"],[12],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,3],[15,6,[30,1,[\"lastPostUrl\"]]],[15,\"aria-label\",[28,[32,23],[\"latest_poster_link\"],[[\"username\"],[[30,1,[\"lastPosterUser\",\"username\"]]]]]],[15,\"data-user-card\",[30,1,[\"lastPosterUser\",\"username\"]]],[12],[1,[28,[32,24],[[30,1,[\"lastPosterUser\"]]],[[\"imageSize\"],[\"large\"]]]],[13],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"topic-item-metadata right\"],[12],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-link\"]],null],[1,\"\\n\\n            \"],[10,0],[14,0,\"main-link\"],[12],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-status\"]],null],[8,[32,7],null,[[\"@topic\"],[[30,1]]],null],[8,[32,8],[[24,0,\"raw-link raw-topic-link\"],[4,[32,4],[\"focus\",[30,0,[\"onTitleFocus\"]]],null],[4,[32,4],[\"blur\",[30,0,[\"onTitleBlur\"]]],null]],[[\"@topic\"],[[30,1]]],null],[41,[30,1,[\"featured_link\"]],[[[1,[28,[32,9],[[30,1]],null]]],[]],null],[8,[32,5],null,[[\"@name\"],[\"topic-list-after-title\"]],null],[41,[30,1,[\"unseen\"]],[[[10,1],[14,0,\"topic-post-badges\"],[12],[1,\" \"],[10,1],[14,0,\"badge-notification new-topic\"],[12],[13],[13]],[]],null],[41,[30,0,[\"expandPinned\"]],[[[8,[32,16],null,[[\"@topic\"],[[30,1]]],null]],[]],null],[8,[32,5],null,[[\"@name\"],[\"topic-list-main-link-bottom\"]],null],[1,\"\\n            \"],[13],[8,[32,5],null,[[\"@name\"],[\"topic-list-after-main-link\"]],null],[1,\"\\n\\n            \"],[10,0],[14,0,\"pull-right\"],[12],[1,\"\\n              \"],[8,[32,25],null,[[\"@topic\",\"@postBadgesEnabled\"],[[30,1],[30,4]]],null],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"topic-item-stats clearfix\"],[12],[1,\"\\n              \"],[10,1],[14,0,\"topic-item-stats__category-tags\"],[12],[1,\"\\n\"],[41,[51,[30,5]],[[[1,\"                  \"],[8,[32,5],null,[[\"@name\"],[\"topic-list-before-category\"]],null],[1,\"\\n                  \"],[1,[28,[32,12],[[30,1,[\"category\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"\\n                \"],[1,[28,[32,13],[[30,1]],[[\"mode\"],[\"list\"]]]],[1,\"\\n              \"],[13],[1,\"\\n\\n              \"],[10,0],[14,0,\"num activity last\"],[12],[1,\"\\n                \"],[10,1],[15,\"title\",[30,1,[\"bumpedAtTitle\"]]],[14,0,\"age activity\"],[12],[1,\"\\n                  \"],[10,3],[15,6,[30,1,[\"lastPostUrl\"]]],[12],[1,[28,[32,26],[[30,1,[\"bumpedAt\"]]],[[\"format\",\"noTitle\"],[\"tiny\",\"true\"]]]],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"]],[\"@topic\",\"@lastVisitedTopic\",\"@bulkSelectEnabled\",\"@showTopicPostBadges\",\"@hideCategory\",\"@tagsForUser\",\"@showPosters\",\"@showLikes\",\"@showOpLikes\"],false,[\"if\",\"unless\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-list/topic-list-item.js",
  "scope": () => [concatClass, concat, eq, didInsert, on, PluginOutlet, hash, TopicStatus, TopicLink, topicFeaturedLink, UnreadIndicator, TopicPostBadges, categoryLink, discourseTags, ParticipantGroups, ActionList, TopicExcerpt, PostersColumn, PostsCountColumn, gt, number, icon, ActivityColumn, i18n, avatar, PostCountOrBadges, formatDate],
  "isStrictMode": true
}), _TopicListItem), _TopicListItem), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "historyStore", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "messageBus", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onMessage", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "onMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "highlightIfNeeded", [action], Object.getOwnPropertyDescriptor(_class.prototype, "highlightIfNeeded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTitleFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTitleFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTitleBlur", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTitleBlur"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyTitleDecorators", [action], Object.getOwnPropertyDescriptor(_class.prototype, "applyTitleDecorators"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBulkSelectToggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBulkSelectToggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "click", [action], Object.getOwnPropertyDescriptor(_class.prototype, "click"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyDown"), _class.prototype)), _class);
export { TopicListItem as default };